import './styles/tokens.css';
import { config } from './config';
import { session } from './core/session';
import { store } from './core/store';
import { outbox } from './core/outbox';
import { createShell } from './ui/shell';
import { injectFonts } from './ui/fonts';
import { showLogin } from './ui/screens/login';
import { showTerms } from './ui/screens/terms';
import { ensureLocation } from './ui/screens/permission';
import { createMapTab } from './tabs/map';
import { createBookTab } from './tabs/book';
import { createPromptsTab } from './tabs/prompts';
import { createCardsTab } from './tabs/cards';
import { createPhotoSubmit } from './flows/submit';
import { createFx } from './fx';
import type { Tab, TabContext } from './tabs/contract';

const asset = (p: string): string => `/assets/${p}`;

async function boot(root: HTMLElement): Promise<void> {
  injectFonts();

  // 1. ログイン（鍵が残っていれば省く）。鍵が切れたらここからやり直す
  let s = session.get();
  if (!s || s.event_id !== config.eventId) {
    session.clear();
    const r = await showLogin(root, config.eventId);
    s = session.get() ?? { ...r, saved_at: Date.now() };
  }
  // 2. 規約の同意（端末ごと）
  if (!s.terms_accepted) await showTerms(root, s.terms_version);
  // 3. 位置情報（必須）
  await ensureLocation(root);

  // 4. ゲーム画面
  root.replaceChildren();
  const shell = createShell(root);
  const fx = createFx(asset);
  const ctx: TabContext = {
    notify: (n) => shell.notify(n),
    switchTab: (id, focus) => shell.select(id, focus),
    submitPhoto: createPhotoSubmit(fx),
    refresh: () => store.refresh(),
    fx,
    asset,
  };
  const tabs: Tab[] = [createMapTab(ctx), createBookTab(ctx), createPromptsTab(ctx), createCardsTab(ctx)];
  shell.mount(tabs);

  store.changed.on(({ state, prev }) => {
    shell.update(state);
    shell.setConnection(null);
    for (const t of tabs) t.update(state, prev);
  });
  store.failed.on((e) => {
    if (e.isNetwork) shell.setConnection('通信できません。電波の良い場所で自動でつながります');
  });
  session.changed.on((info) => {
    if (!info) location.reload(); // 鍵が切れた → ログインから
  });

  store.start();
  outbox.start();
}

const root = document.getElementById('app');
if (root) {
  boot(root).catch((e: unknown) => {
    console.error(e);
    const p = document.createElement('p');
    p.style.cssText = 'margin:40px 16px;padding:16px;background:#F8F0DE;font-family:serif';
    p.textContent = '起動できませんでした。読み込み直してください。';
    root.replaceChildren(p);
  });
}
